import React, { useState, useEffect } from 'react'
import { useConfig } from 'msp-integrations'
import { COUNTRIES_PREFIX } from './PhoneField.helpers'
import { PhoneFieldDropdownLabel } from './partials/PhoneFieldDropdownLabel'
import { PhoneFieldCountrySelect } from './partials/PhoneFieldCountrySelect'
import * as S from './PhoneField.styles'

const PhoneField = ({
  setPrefix,
  initialPrefix
}: {
  setPrefix: (string) => void
  initialPrefix: string
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const {
    theme: {
      font: { regular: font }
    }
  } = useConfig()
  const countriesPrefix = Object.values(COUNTRIES_PREFIX)
  const [selectedCountry, setSelectedCountry] = useState(
    countriesPrefix.find((cP) => String(cP.prefix) === initialPrefix) ||
      countriesPrefix.find((cP) => cP.iso === 'DE')
  )
  useEffect(() => {
    if (selectedCountry) {
      setPrefix(selectedCountry.prefix)
    }
  }, [selectedCountry])

  return (
    <div
      className={S.CountrySelectorWrapper}
      onClick={() => setIsDropdownOpen((iDO) => !iDO)}
    >
      <PhoneFieldCountrySelect
        country={selectedCountry}
        isDropdownOpen={isDropdownOpen}
      />
      {isDropdownOpen && (
        <div
          className={`${font} ${S.CountrySelectorDropdown}`}
          onMouseLeave={() => setIsDropdownOpen(false)}
        >
          {(Object.values(COUNTRIES_PREFIX) || []).map((cP) => (
            <PhoneFieldDropdownLabel
              key={cP.iso}
              country={cP}
              setSelectedCountry={setSelectedCountry}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default PhoneField
